import { useEffect, useRef } from 'react'
import { DataSet } from 'vis-data'
import { Network } from 'vis-network'
import 'vis-network/styles/vis-network.css'

import { Button, Modal } from 'src/common/components'
import { IModal } from 'src/common/interfaces'

import withErrorBoundaryAndPolicyCheck from '../../../../../../v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import styles from './status-transitions-view-modal.module.scss'

interface EligibilityEditorModalProps extends IModal {
  isNew: boolean
  initialValues?: any
}


const StatusTransitionsViewModal = (props: EligibilityEditorModalProps) => {
  const { onClose } = props

  const modalTitle = `Status Transitions`

  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {

    const dataNodes=new Set ([
      ...props.initialValues?.map((d:any) => {
        return d.to
      }),
      ...props.initialValues?.map((d:any) => {
        return d.from
      }),
    ]);


    const nodes = new DataSet(
      Array.from(dataNodes).map((m)=>{
        return {id:m, label:m, level: m==='INITIAL'?0:1 }
      })
    )

    const edges = new DataSet(
      props.initialValues?.map((v:any, i:any, d:any) => {
        return { id: i.toString(), from: v.from, to: v.to }
      }),
    )

    const data = { nodes, edges }

    const options = {
      layout: {
        randomSeed: 100,
        hierarchical: false,
        clusterThreshold: 300
      },
      edges: {
        color: 'rgba(0,0,0,0.64)',
        arrows: 'to'
      },
      nodes: {
        shape: 'box',
        size: 40,
        font: {
          size: 15,
        },
      },
      physics: {
        enabled: false,
      },
    }

    if (containerRef.current) {
      const network = new Network(containerRef.current, data as any, options)

      return () => {
        network.destroy()
      }
    }
  }, [])

  return (
    <Modal id="statusTransitionsViewModal" onClose={onClose}>
      <div className={styles.wrapper}>
        <div className={styles.title}>{modalTitle}</div>

        <div className={styles.inner}>
          <div
            ref={containerRef}
            style={{
              height: '95vh',
              width: '95wh',
              border: '1px solid lightgray',
              borderRadius: '8px',
            }}
          />

          <div className={styles.bottomButtons}>
            <Button size="small" template="secondary" onClick={onClose}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  StatusTransitionsViewModal,
  'is_enable_associated_benefit_contracts_detail',
  true,
)
